module.exports = __webpack_public_path__ + "images/mobile/img-error-403-a11764159140f4d2ac8b11951a55ee30.png";